export const resourceBasePath = '/play/v3';
export const apiBasePath = `${resourceBasePath}/api`;
export const svgBasePath = `${resourceBasePath}/svgs`;
export const imagesBasePath = `${resourceBasePath}/images`;
export const fontsBasePath = `${resourceBasePath}/fonts`;
export const defaultManifestName = 'default.webmanifest';